import { useTranslation } from 'react-i18next';
import { LogIn, Lock } from 'lucide-react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';
import { useLoginModal } from './LoginModal';

export const LoginRequired = ({ feature }) => {
  const { t } = useTranslation();
  const { openLogin } = useLoginModal();

  return (
    <div className="h-screen flex flex-col bg-white">
      <div className="flex-1 flex items-center justify-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center max-w-sm"
        >
          {/* Lock Icon */}
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-amber-900/50 to-blue-900/50 flex items-center justify-center mx-auto mb-6 border border-amber-500/30">
            <Lock className="w-10 h-10 text-amber-400" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-white mb-3 font-['Chakra_Petch']">
            {t('auth.loginRequired', { defaultValue: 'Login Required' })}
          </h2>

          {/* Description */}
          <p className="text-zinc-400 mb-6">
            {t('auth.loginRequiredDesc', { 
              feature: feature || t('common.thisFeature', { defaultValue: 'this feature' }),
              defaultValue: `Please login to access ${feature || 'this feature'}` 
            })}
          </p>

          {/* Login Button */}
          <Button
            onClick={() => openLogin()}
            className="w-full bg-gradient-to-r from-amber-600 to-blue-600 hover:from-amber-700 hover:to-blue-700 text-white h-12 rounded-xl font-semibold flex items-center justify-center gap-2"
            data-testid="login-button"
          >
            <LogIn className="w-5 h-5" />
            {t('auth.login', { defaultValue: 'Login' })}
          </Button>

          {/* Register Link */}
          <p className="text-zinc-500 text-sm mt-4">
            {t('auth.noAccount', { defaultValue: "Don't have an account?" })}{' '}
            <button
              onClick={() => openLogin()}
              className="text-amber-400 hover:text-amber-300 font-medium"
            >
              {t('auth.register', { defaultValue: 'Register' })}
            </button>
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default LoginRequired;
